import Link from '@/components/base/TransitionLink';
import { SHELL, INSET_X, LINE } from '@/components/base/Frame';
import SectionLabel from '@/components/base/SectionLabel';
import SectionLink from '@/components/base/SectionLink';
import { coIntro } from '@/mocks/customerOperations';
import Chapter from './Chapter';

export default function IntroSection() {
  return (
    <Chapter id="top" headerGap>
      <div className={`${SHELL} flex flex-col`}>
        <nav aria-label="Breadcrumb" className={`border-b ${LINE} py-4 ${INSET_X}`}>
          <ol className="flex flex-wrap items-center gap-2 font-label text-[11px] uppercase tracking-[0.12em] text-foreground-500">
            <li><Link to="/" className="cursor-target cursor-pointer whitespace-nowrap hover:text-primary-500">Home</Link></li>
            <li aria-hidden="true">/</li>
            <li><SectionLink section="services" className="cursor-target cursor-pointer whitespace-nowrap hover:text-primary-500">Services</SectionLink></li>
            <li aria-hidden="true">/</li>
            <li className="text-foreground-900">Customer operations</li>
          </ol>
        </nav>

        <div className={`grid grid-cols-1 gap-12 pb-12 pt-14 md:pt-20 lg:grid-cols-[minmax(0,7fr)_minmax(0,4fr)] lg:gap-16 lg:pb-16 lg:pt-28 ${INSET_X}`}>
          <div>
            <SectionLabel index="01" label={coIntro.label} />
            <h1 className="mt-6 text-4xl font-light leading-[1.06] tracking-[-0.02em] text-foreground-950 md:text-5xl lg:text-[60px]">
              <span className="lg:whitespace-nowrap">{coIntro.title.split(', ')[0]},</span>
              <br />
              <span className="lg:whitespace-nowrap">{coIntro.title.split(', ').slice(1).join(', ')}</span>
            </h1>
            <p className="mt-8 max-w-[34rem] text-base font-light leading-relaxed text-foreground-700 md:text-lg">
              {coIntro.desc}
            </p>
            <Link
              to="/contact"
              className="group cursor-target mt-10 inline-flex cursor-pointer items-center gap-3 whitespace-nowrap border-b border-primary-500 pb-1 text-sm text-primary-600 transition-colors hover:text-primary-700"
            >
              Book a consultation
              <span className="transition-transform duration-300 group-hover:translate-x-1">&rarr;</span>
            </Link>
          </div>

          <dl className={`self-end border-t ${LINE} font-label text-[11px] uppercase tracking-[0.12em]`}>
            {coIntro.meta.map((m) => (
              <div key={m.k} className={`flex justify-between gap-6 border-b ${LINE} py-3`}>
                <dt className="text-foreground-500">{m.k}</dt>
                <dd className="text-right text-foreground-900">{m.v}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </Chapter>
  );
}